import { Loader } from '@components/loader';
import { usePusherLoaderStore } from '@stores/pusher-loader-store';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

export const GlobalLoader = () => {
  // Count queries that don't have meta.hideLoader = true
  const isFetchingCount = useIsFetching({
    predicate: (query) => {
      const hideLoader = query.meta?.hideLoader as boolean | undefined;
      return hideLoader !== true;
    },
  });

  // Count mutations that don't have meta.hideLoader = true
  const isMutatingCount = useIsMutating({
    predicate: (mutation) => {
      const hideLoader = mutation.meta?.hideLoader as boolean | undefined;
      return hideLoader !== true;
    },
  });

  // Get Pusher-specific loading state
  const isPusherLoading = usePusherLoaderStore((state) => state.isLoading);

  const isLoading = isFetchingCount > 0 || isMutatingCount > 0 || isPusherLoading;

  if (!isLoading) return null;

  return (
    <div
      data-testid='global-loader'
      className='fixed w-screen h-screen flex justify-center items-center bg-primary z-50 transition-opacity opacity-100'>
      <Loader />
    </div>
  );
};
